import React from "react"
import { ConfirmSignUp } from "aws-amplify-react"



export class ArchieConfirmSignUp extends ConfirmSignUp {
  constructor(props) {
    super(props)
    this._validAuthStates = ["confirmSignUp"]
    this.handleSubmit = this.handleSubmit.bind(this)
  }

  handleSubmit(e) {
    e.preventDefault()
    super.confirm()
  }

  showComponent() {
    const username = this.usernameFromAuthData()

    return (
      <div className="auth__signin">
        <form className="auth__form form" onSubmit={this.handleSubmit} method="POST">
          <div className="field">
            <label
              className="field__label"
              htmlFor="username"
            >
              Email
            </label>
            <input
              className="field__input"
              id="username"
              key="username"
              name="username"
              disabled={username}
              value={username ? username : ""}
              onChange={this.handleInputChange}
              type="text"
              required
            />
          </div>

          <div className="field">
            <div className="field__header">
              <label
                className="field__label"
                htmlFor="code"
              >
                Confirmation Code (Email)
              </label>
              <div className="field__help">
                <a className="link" onClick={() => {alert("Confirmation code resent"); super.resend()}}>
                  Resend Code
                </a>
              </div>
            </div>
            <input
              className="field__input"
              id="code"
              key="code"
              name="code"
              autoComplete="off"
              placeholder="Enter your code"
              onChange={this.handleInputChange}
              type="text"
              required
            />
          </div>

          <div className="form__actions">
            <button className="button button--large">
              Confirm
            </button>
          </div>
          <div className="form__help">
            <a
              className="link"
              onClick={() => super.changeState("signIn")}
            >
              Back to sign in
            </a>
          </div>
        </form>
      </div>
    )
  }
}


export default ArchieConfirmSignUp
